import React, { useEffect, useCallback, useState} from 'react';
import CirklonModeButton from './CirklonModeButton.js';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';
import {
    setCirklonParameterSelected,
    setStepParameterSelected
} from 'actions/index.js';

/*
const PARAMS = [
    "Duration",
    "Transpose",
    "Velocity",
    "Chop",
    "Panning",
];

*/

const CirklonParameterChooser = ({
    color,
    parameter,
    setParameter,
    track,
    stepDatas,
    setStepParameterSelected,
    stepParameterSelected,
}) => { 
    const PARAMS = track.getStepDataParams();
    const [parameters, setParameters] = useState([... PARAMS]);

    const options = PARAMS.map(
        x => ({label: x, value: x}));

    useEffect(() => {
        if (stepParameterSelected) {
            setParameter(stepParameterSelected);
        }
    }, [stepParameterSelected, setParameter]);

    const onChange = useCallback((opt) => {
        setParameter(opt.value);
        setStepParameterSelected(opt.value);
    }, [setParameter, setParameters, parameters]);

    useEffect(() => {
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [setParameter]);

    const onKey = useCallback((e) => {
        if (e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA') {
            return;
        }

        if (e.key === 'D') {
            setParameter("Duration");
            setStepParameterSelected("Duration");
        } else if (e.key === "V") {
            setParameter("Velocity");
            setStepParameterSelected("Velocity");
        } else if (e.key === "S") {
            setParameter("Slice");
            setStepParameterSelected("Slice");
        } else if (e.key === "T") {
            setParameter("Transpose");
            setStepParameterSelected("Transpose");
        } else if (e.key === "C") {
            setParameter("Chop");
            setParameter("Chop");
        } else if (e.key === "P") {
            setParameter("Panning");
        }
    }, [setParameter]);

    let style = {
        backgroundColor: color
    };

    useEffect(() => {
        if (!parameter) {
            setParameter("Velocity");
        }
    }, [parameter]);

    return (
        <div
          onMouseDown={e => e.stopPropagation()}
          className="cirklon-parameter-chooser">
          {parameters.map(
              (x,i) =>
                  <div
                    key={i}
                    style={
                        parameter === x ? style : {}
                    }
                    onClick={() => onChange({value: x})}
                    className={(parameter === x ? "param-btn selected" : "param-btn") + " " + x.split(" ").join("")}>{x}</div>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      parameter: state.cirklon.cirklonParameterSelected[props.track.id],
      stepParameterSelected: state.cirklon.stepParameterSelected
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setParameter: param => dispatch(setCirklonParameterSelected(props.track.id, param)),
      setStepParameterSelected: param => dispatch(setStepParameterSelected(param)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CirklonParameterChooser);
